import React from 'react';
import { Tooltip, Whisper } from 'rsuite';

/**
 * What the hours field is called, which depends on the employee's
 * classification: a non-exempt employee is measured against target hours, an
 * exempt one against the share of their total available working hours they are
 * expected to work.
 *
 * TAWH is house shorthand, so the exempt label carries the expansion in a
 * tooltip rather than spelling it out and taking three times the width.
 */
export default function HoursMeasureLabel({ nonExempt = false }) {
  if (nonExempt) return <>Target Hours</>;

  return (
    <span className="bdc-label-info">
      % of TAWH
      <Whisper
        placement="top"
        trigger={['hover', 'focus']}
        speaker={<Tooltip>Total Available Working Hours</Tooltip>}
      >
        <i
          className="bi bi-info-circle"
          role="img"
          aria-label="Total Available Working Hours"
          tabIndex={0}
        />
      </Whisper>
    </span>
  );
}
